/**
 * Created by shaharshelly on 01/02/2016.
 */
import app from 'app';
import Marionette from 'backbone.marionette';

export default Marionette.ItemView.extend({
  template: app.compileTemplate.$('#video-share-facebook-tml'),
  className: 'wt-video-share wt-editor-modal',
  ui: {
    closeButton: '.js-action-cancel',
    uploadButton: '.js-action-upload',
    title: '.js-video-share-input-title',
    description: '.js-video-share-input-description',
    titleError: '.js-video-share-input-title-error',
    titleCount: '.js-video-share-input-title-count',
    socialVideoTargets: '.js-social-video-targets',
    socialVideoTargetLabel: '.js-social-video-target-label',
    socialVideoTargetSeparator: '.js-social-video-separator',
    socialVideoTargetsList: '.js-social-video-targets  ul',
    descriptionError: '.js-video-share-input-description-error',
    descriptionCount: '.js-video-share-input-description-count',
    privacyStatus: '.js-privacy-status',
  },
  events: {
    'click @ui.closeButton': '_close',
    'click @ui.uploadButton': '_upload',
    'input @ui.description': '_checkDescription',
    'click @ui.socialVideoTargetsList li': '_selectSocialVideoTarget',
    'propertychange @ui.description': '_checkDescription',
    'input @ui.title': '_checkTitle',
    'keydown @ui.title': '_ignoreSpace',
    'keydown @ui.description': '_ignoreSpace',
  },
  // as facebook is the only client of this code +
  // the code is not longer relevant in the backend the resource route
  onShow: function () {
    this.isTitleValid = true;
    this.isDescriptionValid = true;
    this.targetId = '';
    this._checkTitle();
    this._checkDescription();
    this.ui.socialVideoTargets.hide();
    this.ui.socialVideoTargetSeparator.hide();
    this.gotoPage = app.stash.get('selectedFacebookPage');
    let $li;
    let value;
    let label;
    if (this.options.provider === 'facebook') {
      app.api.getSocialVideoTargetsList
        .get({ providerName: this.options.provider })
        .done(
          function (response) {
            if (
              response.userProfile &&
              response.socialProviderTargets &&
              response.socialProviderTargets.length !== 0
            ) {
              this._appendToDropBox(
                response.userProfile,
                response.socialProviderTargets
              );
              if (this.gotoPage) {
                ($li = $('[data-value=' + this.gotoPage + ']')),
                  (value = $li.data('value')),
                  (label = $li.html());
                this._setTarget($li, label, value);
              }
              this.ui.socialVideoTargets.show();
              this.ui.socialVideoTargetSeparator.show();
              this.$('.wt-modal-body').height(496);
            }
          }.bind(this)
        )
        .fail(function (response) {
          console.log('getSocialVideoTargetsList fail', response);
        });
    }
    if (app.keyboardAccessibility.isUnique('wt-video-share')) {
      app.keyboardAccessibility.add('wt-video-share', [
        {
          on: 'keydown',
          key: $.ui.keyCode.ESCAPE,
          run: this._close.bind(this),
        },
      ]);
    }
  },
  textAbstract: function (text, length) {
    if (text == null) {
      return '';
    }
    if (text.length <= length) {
      return text;
    }
    text = text.substring(0, length);
    const last = text.lastIndexOf(' ');
    if (last >= 0) {
      text = text.substring(0, last);
    }

    return text + '...';
  },

  _appendToDropBox: function (userProfile, socialProviderTargets) {
    let labelText = '';
    const label =
      '<img class="wt-image-url" src="' +
      userProfile.imageUrl +
      '"/><a href="#">Upload to my videos</a>';
    this.ui.socialVideoTargetsList.append(
      '<li data-value=""  data-label="Upload to ' +
        userProfile.name +
        '\'s timeline" class="selected">' +
        label +
        '</li>'
    );

    socialProviderTargets.forEach(
      function (target) {
        labelText = this.textAbstract(
          'Upload to ' + target.targetName + ' videos',
          42
        );
        this.ui.socialVideoTargetsList.append(
          '<li data-value="' +
            target.targetId +
            '" data-label=" ' +
            target.targetName +
            ' ">' +
            '<img class="wt-image-url" src="' +
            target.targetImage +
            '"><a href="#">' +
            labelText +
            '</a></li>'
        );
      }.bind(this)
    );

    $(this.ui.socialVideoTargetLabel).html(label);
  },

  _ignoreSpace: function (e) {
    const code = e.keyCode ? e.keyCode : e.which; // to support both methods
    if (code == 32) {
      // the space keycode
      e.stopPropagation();
    }
  },
  _checkTitle: function () {
    this.isTitleValid = true;
    if (this.options.provider != 'twitter') {
      const count = this.ui.title.val().length;
      this.ui.titleCount.html(100 - count);
      if (this.ui.title.val().length <= 0) {
        this.isTitleValid = false;
        this._updateUploadButton();
        return;
      }
      this.ui.titleError.hide();
      this.ui.titleError.html('');
      if (this.ui.title.val().length > 100) {
        this.ui.titleCount.addClass('error');
        this.isTitleValid = false;
      } else {
        this.ui.titleCount.removeClass('error');
      }
      this._updateUploadButton();
    }
  },
  _updateUploadButton: function () {
    if (this.isTitleValid && this.isDescriptionValid) {
      this.ui.uploadButton.removeClass('disabled');
    } else {
      this.ui.uploadButton.addClass('disabled');
    }
  },
  _checkDescription: function () {
    this.isDescriptionValid = true;
    const isTwitter = this.options.provider == 'twitter';
    const max = isTwitter ? 100 : 5000;
    const min = isTwitter ? 1 : 0;
    const count = this.ui.description.val().length;
    this.ui.descriptionCount.html(max - count);
    if (count > max || count < min) {
      this.isDescriptionValid = false;
      if (isTwitter) {
        if (count < min) {
          this.ui.descriptionError.show();
          this.ui.descriptionError.html('The tweet must not be blank');
        } else {
          this.ui.descriptionCount.addClass('error');
        }
      } else {
        this.ui.descriptionCount.addClass('error');
      }
    } else {
      this.ui.descriptionCount.removeClass('error');
      this.ui.descriptionError.html('');
      this.ui.descriptionError.hide();
    }
    this._updateUploadButton();
  },
  _upload: function () {
    if (this.isDescriptionValid && this.isTitleValid) {
      if (this.options.provider == 'twitter') {
        this.trigger('share:upload', {
          title: this.ui.description.val(),
          description: this.ui.description.val(),
        });
        this._close();
      } else if (this.options.provider === 'facebook') {
        this.trigger('share:upload', {
          title: this.ui.title.val(),
          description: this.ui.description.val(),
          targetId: this.targetId,
        });
      } else {
        this.trigger('share:upload', {
          title: this.ui.title.val(),
          description: this.ui.description.val(),
          privacyStatus: this.ui.privacyStatus.val(),
        });
      }
    } else {
      if (!this.isTitleValid) {
        this.ui.titleError.html('The video has to have a title');
        this.ui.titleError.show();
      }
    }
    this._close({ trigger: false });
  },

  _close: function (options) {
    options = Object.assign(
      {
        trigger: true,
      },
      options
    );
    app.controller.hideModal();
    app.keyboardAccessibility.remove('wt-video-share');
    options.trigger && this.trigger('share:close');
  },

  serializeData: function () {
    let providerName = _.capitalize(this.options.provider);
    if (this.options.provider == 'youtube') {
      providerName = 'YouTube';
    }
    const programmerId = this.model.get('programmerId');
    const programmer = app.programmers.get(programmerId);
    const privacyStatus = programmer.get('youtubeUploadPrivacyStatus');
    const context = {
      title: this.model.get('title'),
      description: this.model.get('description'),
      provider: this.options.provider,
      providerName: providerName,
      twitter: this.options.provider == 'twitter',
      privacyStatus: privacyStatus || 'PUBLIC',
    };
    return context;
  },

  _selectSocialVideoTarget: function (e) {
    e.preventDefault();
    const $li = $(e.currentTarget);
    const value = $li.data('value');
    const label = $li.html();
    this._setTarget($li, label, value);

    app.stash.set('selectedFacebookPage', value);
  },

  _setTarget: function ($li, label, value) {
    $li.addClass('selected').siblings().removeClass('selected');
    $(this.ui.socialVideoTargetLabel).html(label);
    this.targetId = value;
  },
});
